module.exports = __webpack_public_path__ + "img/logo.56e4606c.svg";